import styled from "@emotion/styled";
import { MDSMenuItem, MDSText } from "@/mds";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["4"]};
  padding: ${({ theme }) => theme.spacing["4"]};
  width: min(400px, 90vw);
  max-width: 90vw;
  background-color: ${({ theme }) => theme.colors.surface.preview};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  overflow: hidden;
`;

export const StyledRow = styled.div<{ align?: "center" | "start" }>`
  display: flex;
  flex-direction: row;
  align-items: ${({ align = "start" }) => (align === "center" ? "center" : "flex-start")};
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const StyledLabel = styled(MDSText)`
  width: 75px;
  flex-shrink: 0;
`;

export const StyledValue = styled(MDSText)`
  flex: 1;
  min-width: 0;
`;

export const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: ${({ theme }) => theme.spacing["1"]};
`;

export const StyledShowMore = styled(MDSText)`
  cursor: pointer;
`;

export const StyledLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  width: 100%;
`;

export const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  min-width: 0;
`;

export const StyledGuestsContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const StyledGuestsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  cursor: pointer;
  user-select: none;
  margin-bottom: ${({ theme }) => theme.spacing["1"]};
`;

export const StyledGuestMenuItem = styled(MDSMenuItem)`
  padding-inline: 0;
  cursor: default;

  &:hover:not([data-disabled]),
  :hover:not([data-disabled]) & {
    background-color: inherit;
  }
`;

export const StyledGuestItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  min-width: 0;
`;

export const StyledAttachmentsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-top: ${({ theme }) => `${theme.spacing["4"]}`};
  border-top: 1px solid ${({ theme }) => theme.colors.border.default};
`;
